import { isValidLanguage, MimeType } from '@repo/shared';
import { z } from 'zod';

type LanguageCode = string;

export const createTextTranslationWithDatasetSchema = z.object({
  datasetId: z.string(),
  models: z.array(z.string()).min(1),
});

export type CreateTextTranslationWithDatasetSchema = z.infer<
  typeof createTextTranslationWithDatasetSchema
>;

export const createTextTranslationWithFileSchema = z
  .object({
    files: z.array(z.instanceof(File)),
    sourceLanguageCode: z.custom<LanguageCode>(isValidLanguage),
    targetLanguageCode: z.custom<LanguageCode>(isValidLanguage),
    model: z.string(),
  })
  .superRefine((data, ctx) => {
    const isJSON = data.files.every(
      (file: File) => file.type === MimeType.JSON
    );

    if (!isJSON) {
      if (!data.sourceLanguageCode) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Source language code is required for non-JSON files',
          path: ['sourceLanguageCode'],
        });
      }
      if (!data.targetLanguageCode) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Target language code is required for non-JSON files',
          path: ['targetLanguageCode'],
        });
      }
    }
  });

export type CreateTextTranslationWithFileSchema = z.infer<
  typeof createTextTranslationWithFileSchema
>;

export const createTextTranslationWithModelRunSchema = z.object({
  modelRunId: z.string(),
  models: z.array(z.string()).min(1),
});

export type CreateTextTranslationWithModelRunSchema = z.infer<
  typeof createTextTranslationWithModelRunSchema
>;

export const createTextTranslationWithTextSchema = z.object({
  input: z.string(),
  reference: z.string().optional(),
  sourceLanguageCode: z.custom<LanguageCode>(isValidLanguage),
  targetLanguageCode: z.custom<LanguageCode>(isValidLanguage),
  models: z.array(z.string()).min(1),
});

export type CreateTextTranslationWithTextSchema = z.infer<
  typeof createTextTranslationWithTextSchema
>;
